export const REPORTREFUNDS_SEARCH = 'REPORTREFUNDS_SEARCH';
export const REPORTREFUNDS_PAGE = 'REPORTREFUNDS_PAGE';
export const REPORTREFUNDS_STARTDATE = 'REPORTREFUNDS_STARTDATE';
export const REPORTREFUNDS_ENDDATE = 'REPORTREFUNDS_ENDDATE';
export const REPORTREFUNDS_USER = 'REPORTREFUNDS_USER';
export const REPORTREFUNDS_COUNTRY = 'REPORTREFUNDS_COUNTRY';
export const REPORTREFUNDS_STATUS = 'REPORTREFUNDS_STATUS';
export const REPORTREFUNDS_THREEPSUPPLIER = 'REPORTREFUNDS_THREEPSUPPLIER';